<script setup>
import XlSkeleton from '../xl/XlSkeleton.vue';

/**
 * A session row before its data is here: PortalSessionRow's own frame — the
 * card, the date tile, the title, the meta line, the tags and the way in —
 * with placeholders where the words go, so the list does not move when the
 * rows land (QA: Portal Sessions shifted when data arrived). Each placeholder
 * sits on the line its text will, at that text's size.
 */
defineProps({
  // Varied, so a column of rows does not read as one slab.
  titleWidth: { type: String, default: '58%' },
  metaWidth: { type: String, default: '40%' },
});
</script>

<template>
  <article class="ev ev--loading" aria-busy="true" data-testid="session-card-loading">
    <div class="ev__row">
      <div class="ev__date">
        <span class="ev__m"><XlSkeleton width="26px" height="0.9em" radius="5px" class="ev__sk" /></span>
        <span class="ev__d"><XlSkeleton width="24px" height="0.9em" radius="6px" class="ev__sk" /></span>
      </div>
      <div class="ev__in">
        <span class="ev__title"><XlSkeleton :width="titleWidth" height="0.9em" radius="7px" class="ev__sk" /></span>
        <span class="ev__meta"><XlSkeleton :width="metaWidth" height="0.9em" radius="6px" class="ev__sk" /></span>
        <div class="ev__tags">
          <XlSkeleton width="74px" height="24px" radius="99px" class="ev__sk ev__sk--tag" />
          <XlSkeleton width="66px" height="24px" radius="99px" class="ev__sk ev__sk--tag" />
        </div>
      </div>
      <div class="ev__act">
        <XlSkeleton width="118px" height="34px" radius="99px" class="ev__sk ev__sk--tag" />
      </div>
    </div>
  </article>
</template>

<style scoped>
/* PortalSessionRow's frame, kept in step with it. */
.ev {
  margin-bottom: 10px; background: #fff; border: 1px solid var(--xl-color-border); border-radius: 18px;
  box-shadow: var(--xl-shadow-1);
}
.ev__row { position: relative; display: flex; align-items: center; gap: 16px; padding: 16px 18px; }
.ev__date {
  width: 58px; flex: 0 0 58px; padding: 9px 0; border-radius: 12px; text-align: center;
  background: var(--xl-color-primary-container); display: flex; flex-direction: column; align-items: center;
  align-self: stretch; justify-content: flex-start;
}
.ev__m { font-size: 10.5px; font-weight: 700; }
.ev__d { font-size: 21px; font-weight: 600; line-height: 1.1; }
.ev__in { flex: 1; min-width: 0; display: flex; flex-direction: column; align-items: stretch; gap: 2px; }
.ev__title { font-size: 15.5px; font-weight: 700; }
.ev__meta { font-size: 13px; }
.ev__tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
.ev__act { flex: 0 0 auto; display: flex; align-items: center; }
.ev__sk { vertical-align: middle; }
.ev__sk--tag { width: auto; }

@media (max-width: 600px) {
  .ev__row { flex-wrap: wrap; row-gap: 12px; }
  .ev__in { flex-basis: calc(100% - 74px - 25px); }
  .ev__act { order: 3; margin-left: 74px; }
}
</style>
